var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.75C5.67875 1.75 1.75 5.67875 1.75 10.5C1.75 15.3212 5.67875 19.25 10.5 19.25C15.3212 19.25 19.25 15.3212 19.25 10.5C19.25 5.67875 15.3212 1.75 10.5 1.75ZM14.0525 9.86125L10.9637 12.95C10.8325 13.0813 10.6663 13.1425 10.5 13.1425C10.3337 13.1425 10.1675 13.0813 10.0363 12.95L6.9475 9.86125C6.69375 9.6075 6.69375 9.1875 6.9475 8.93375C7.20125 8.68 7.62125 8.68 7.875 8.93375L10.5 11.5588L13.125 8.93375C13.3787 8.68 13.7987 8.68 14.0525 8.93375C14.3062 9.1875 14.3062 9.59875 14.0525 9.86125Z",
    fill: "#FF4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropIcon);
export default __webpack_public_path__ + "static/media/dropIcon.a7e6e5867fd4c919d3991d6d0dbd484a.svg";
export { ForwardRef as ReactComponent };